import { findManagedVenue } from '@/lib/venue/managerVenueTypes'

import { useManagedVenues } from './useManagedVenues'

export interface ReservationAvailability {
  isLoading: boolean
  /** 판정 불가(로딩·미소속) 상태에선 항상 false — 소비처가 이 값을 fail-closed 로 쓴다. */
  reservationAvailable: boolean
}

/**
 * "예약 기능 사용 가능 여부"를 요구사항 원문 그대로 판정한다: 예약 기능 설정 ON ∧ 운영 인증 완료
 * (구 `useVenueGating`의 이용권 축 판정을 대체 — 설계 §2 자율 결정).
 *
 * 🚨 새 쿼리를 만들지 않는다 — `useManagedVenues` 는 `VenueLayout`(소속 검사)이 이미 구독 중인 쿼리라
 * 네트워크 요청이 중복되지 않는다.
 * 🚨 서버의 `RESERVATION_ENABLED` 게이트(`reservationEnabled`만 봄)보다 엄격하지만, 서버 409가 최종
 * 방어선이므로 클라이언트가 더 보수적으로 미리 막아도 안전하다(설계 §2 자율 결정).
 */
export function useReservationAvailability(venueId: string): ReservationAvailability {
  const venuesQuery = useManagedVenues()
  const venue = findManagedVenue(venuesQuery.data, venueId)

  return {
    isLoading: venuesQuery.isLoading,
    reservationAvailable: venue
      ? venue.reservationEnabled && venue.operationVerification.status === 'VERIFIED'
      : false,
  }
}
